// config.js
export const BASE_URL = "https://pushing-reaching-limited-continental.trycloudflare.com";
export const redirect_uri = "https://jamye.p-e.kr/oauth/redirect";
export const IMAGE_URL = "https://d23eha8a4ssn72.cloudfront.net";
export const redirectBaseUrl= "https://jamye.p-e.kr";
 
// export const BASE_URL = "http://localhost:8080";
// export const redirect_uri = "http://localhost:8081/oauth/redirect";
// export const redirectBaseUrl= "http://localhost:8081";
// export const IMAGE_URL = "http://jamye-image-local.s3-website.ap-northeast-2.amazonaws.com";
